<script setup lang="ts">
import AccountPermsForm from '@/modules/account/components/AccountPermsForm.vue'
import { Form } from '@primevue/forms'
import { computed, onMounted, ref, watch } from 'vue'
import { uuid } from 'vue3-uuid'
import { initialValuesCreateBOAccount } from '../helper/form'
import { yupResolver } from '@primevue/forms/resolvers/yup'
import { schemaCreateBOAccount } from '../helper/validationAccountSchema'
import { useConfirm, useToast } from 'primevue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import AccountAPI from '../constants/account.api.uri.const'
import { useRouter } from 'vue-router'
import ImagePicker from '@/onenetwork/components/image_picker/ImagePicker.vue'
import { useAccountListStore } from '../stores/account.list.store'
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import Card from 'primevue/card'

const confirm = useConfirm();
const formRef = ref();
const router = useRouter();
const toast = useToast();
const accountListStore = useAccountListStore()
const statusOptions = [
  { name: 'Hoạt động', code: true },
  { name: 'Không Hoạt động', code: false }
]
const initialValues = ref({
  ...initialValuesCreateBOAccount,
})

onMounted(() => {

})

// const handleSavePerms = () => {
//   console.log('handleSavePerms', accountBODetailStore.accounts[props.id].account.perms)
//   boPermsEditable.value = false
// }

const resolver = yupResolver(schemaCreateBOAccount);

const createBOAccount = async (data: any) => {
  try{
    const res = await APIClient.post(AccountAPI.bo.create, data);
    if (res.data.code === 200) {
      toast.add({ severity: 'success', summary: 'Success', detail: 'Đăng kí thành công', life: 3000 });
      //fetch account bo list
      accountListStore.fetchList();
      setTimeout(() => {
        router.push({ name: 'account-bo' })
      }, 2000)
    }
  } catch (e: any) {
    const errorMessage = e.response?.data?.errors[0]?.error || 'Đã có lỗi xảy ra';
    toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
  }
}


const onFormSubmit = ({ values, valid }: { values: Record<string, any>; valid: boolean }) => {

  if (!valid) return
  confirm.require({
    message: 'Bạn có muốn lưu các chỉnh sửa?',
    header: 'Xác nhận',
    // icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true,
    },
    acceptProps: {
      label: 'Đồng ý',
    },
    accept: () => {
      createBOAccount(values)
    },
    reject: () => {
      // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    },
  })
}

const handleChangeAvatar = (image: any) => {

  if (formRef.value && image?.uuid) {
    formRef.value.setFieldValue('profile_image', image.uuid)
  }
}

const onChange = (value: any) => {

  formRef.value?.setFieldValue('permissions', value);
}

const selectStatus = ref({
  activation_status: initialValues.value.activation_status
    ? statusOptions[0].code
    : statusOptions[1].code
})

watch(() => initialValues.value.activation_status, (newVal) => {
  selectStatus.value.activation_status = newVal
})


</script>
<template>
  <DashboardLayout currentRoute="account/bo/create" page-title="Quản lý Tài khoản BO • Tạo mới">
    <Form
      v-slot="$form"
      ref="formRef"
      :resolver="resolver"
      :initial-values="initialValues"
      @submit="onFormSubmit"
      class="flex w-full"
    >
      <div class="flex w-full gap-5 m-5">
        <div class="flex flex-3 flex-col">
          <Card>
            <template #title>
              <div class="flex justify-between">
                <div>Thông tin tài khoản:</div>
              </div>
            </template>
            <template #content>
              <div class="pt-3">
                <div class="flex gap-5 w-full">
                  <div class="flex flex-1">
                    <image-picker
                      type="photo"
                      :uuid="uuid.v4().toString()"
                      folder="user"
                      height="150px"
                      :upload="true"
                      @action:upload-success="handleChangeAvatar"
                    />
                  </div>
                  <InputText name="profile_image" hidden type="text" class="form-control" />
                  <div class="flex-3">
                    <div class="flex mb-3 gap-3">
                      <div class="flex-1 text-right">Họ và tên:</div>
                      <div class="flex-2">
                        <InputText name="full_name" type="text" class="form-control" />
                        <span class="italic text-[12px] text-red-500" v-if="$form.full_name?.invalid">
                          {{ $form.full_name.error.message }}
                        </span>
                      </div>
                    </div>
                    <div class="flex mb-3 gap-3">
                      <div class="flex-1 text-right">Số điện thoại:</div>
                      <div class="flex-2">
                        <InputText
                          name="phone_number"
                          type="text"
                          class="form-control"
                          maxlength="10"
                          @keypress="(e) => {
                            const charCode = (e.which) ? e.which : e.keyCode;
                            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                              e.preventDefault();
                            }
                          }"
                          @paste="(e: ClipboardEvent) => {
                            e.preventDefault();
                            const text = e.clipboardData?.getData('text') || '';
                            const numbers = text.replace(/\D/g, '').slice(0, 10);
                            formRef.value?.setFieldValue('phone_number', numbers);
                          }"
                        />
                        <span class="italic text-[12px] text-red-500" v-if="$form.phone_number?.invalid">
                          {{ $form.phone_number.error.message }}
                        </span>
                      </div>
                    </div>
                    <div class="flex mb-3 gap-3">
                      <div class="flex-1 text-right">Email:</div>
                      <div class="flex-2">
                        <InputText name="email" type="text" class="form-control" />
                        <span class="italic text-[12px] text-red-500" v-if="$form.email?.invalid">
                          {{ $form.email.error.message }}
                        </span>
                      </div>
                    </div>
                    <div class="flex mb-3 gap-3">
                      <div class="flex-1 text-right">Mật khẩu:</div>
                      <div class="flex-2">
                        <InputText name="password" type="password" class="form-control" />
                        <span class="italic text-[12px] text-red-500" v-if="$form.password?.invalid">
                          {{ $form.password.error.message }}
                        </span>
                      </div>
                    </div>
                    <div class="flex mb-3 gap-3">
                      <div class="flex-1 text-right">Xác nhận mật khẩu:</div>
                      <div class="flex-2">
                        <InputText name="password_confirmation" type="password" class="form-control" />
                        <span class="italic text-[12px] text-red-500" v-if="$form.password_confirmation?.invalid">
                          {{ $form.password_confirmation.error.message }}
                        </span>
                      </div>
                    </div>
                    <div class="flex mb-3 gap-3">
                      <div class="flex-1 text-right">Trạng thái hoạt động:</div>
                      <div class="flex-2">
                        <Select
                          name="activation_status"
                          v-model="selectStatus.activation_status"
                          :options="statusOptions"
                          optionLabel="name"
                          optionValue="code"
                          placeholder="Chọn trạng thái"
                          class="form-control"
                        />
                        <span class="italic text-[12px] text-red-500" v-if="$form.activation_status?.invalid">
                          {{ $form.activation_status.error.message }}
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </template>
          </Card>
        </div>
        <div class="flex flex-5 flex-col">
          <Card>
            <template #title>
              <div class="flex justify-between">
                <div>Quyền hạn</div>
                <div class="flex gap-2">
                  <button type="submit" class="btn btn-cs success lg">Tạo tài khoản</button>
                </div>
              </div>
            </template>
            <template #content>
              <AccountPermsForm :id="null" :editable="true" @update:perms="onChange"/>
              <InputText name="permissions" hidden class="form-control" />
            </template>
          </Card>
        </div>
      </div>
    </Form>
  </DashboardLayout>
</template>
<style scoped></style>
